import { useEffect, useState } from "react";
import "./services-price.scss";
import { Helmet } from "react-helmet-async";
import ServicesAccordion from "./accordion";

export default function ServicesPage({ host }) {
  const [categories, setCategories] = useState([]);
  const [openCategoryId, setOpenCategoryId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${host}/services/`)
      .then((res) => res.json())
      .then((data) => {
        setCategories(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [host]);

  const handleToggle = (categoryId) => {
    setOpenCategoryId((prev) =>
      prev === categoryId ? null : categoryId
    );
  };

  return (
    <section className="price">
      <>
          <Helmet>
              <title>Pro Moto - Cennik Serwisu Motocyklowego</title>
              <meta
              name="description"
              content=" Profesjonalny serwis motocyklowy w Poznaniu. Sprawdź nasze ceny i umów
            się na wizytę."
              />
              <link rel="canonical" href="https://promotoserwis.pl/cennik" />
          </Helmet>
      </>      
      <header className="price-header">
        <div className="overlay"></div>

        <div className="content">
          <h1>Cennik Serwisu Motocyklowego</h1>
          <p>
            Profesjonalny serwis motocyklowy w Poznaniu. Sprawdź nasze ceny i umów
            się na wizytę.
          </p>
        </div>
      </header>

      <div className="price-container">
        {/* Spinner */}
        {loading && <div className="spinner"></div>}

        {!loading &&
          categories.map((cat) => (
            <ServicesAccordion
              key={cat.id}
              category={cat}
              isOpen={openCategoryId === cat.id}
              onToggle={() => handleToggle(cat.id)}
            />
          ))}
      </div>

      <p className="price-footer">
        Wszystkie inne niewymienione czynności, usługi, prace są wyceniane
        indywidualnie zawsze na początku zlecenia przed przystąpieniem do pracy.<br /><br />
        Powyższy cennik nie stanowi oferty dla klienta a zawarte w nim ceny
        są poglądowe w rozumieniu prawa cywilnego, art. 71 kodeksu cywilnego
        i stanowią zaproszenie do zawarcia umowy/zlecenia wykonania usługi.<br /><br />
        Wszystkie ceny zawarte w cenniku są cenami brutto i
        zawierają podatek VAT 23%. Na usługę wystawiamy paragon bądź fakturę VAT.
      </p>

      <div className="price-contact">
        <h2>Potrzebujesz wyceny?</h2>
        <p>Skontaktuj się z nami telefonicznie lub napisz do nas.
          Doradzimy i pomożemy w doborze odpowiedniego zakresu usług.</p>
        <a href="tel:+48535744816" className="price-contact_phone">Zadzwoń teraz</a>
      </div>
    </section>
  );
}
